<template>
    <div id="header" class="shadow">
        <div class="header_logo">
            <img src="@/assets/smallLogo.png" alt="" @click="router.push('/')" />
            <div class="bo_sch_content">
                <DateRange :date="state.searchDate" @changeDate="selectDate"></DateRange>
            </div>
            <div class="header_menu">
                <div class="menu_info">
                    <button
                        class="menu_title"
                        :class="{ active: menu.platform.map((item) => item.idx).some((idx) => global.selectMenu === idx) }"
                    >
                        플랫폼
                    </button>
                    <div class="menu_item">
                        <ul>
                            <li :class="{ active: global.selectMenu === item.idx }" v-for="item in menu.platform" @click="movePage(item)">
                                {{ item.title }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="menu_info">
                    <button
                        class="menu_title"
                        :class="{ active: menu.watcherBot.map((item) => item.idx).some((idx) => global.selectMenu === idx) }"
                    >
                        왓쳐봇
                    </button>
                    <div class="menu_item">
                        <ul>
                            <li
                                :class="{
                                    active: global.selectMenu === item.idx,
                                    disabled: item.isDisabled,
                                }"
                                v-for="item in menu.watcherBot"
                                @click="movePage(item)"
                            >
                                {{ item.title }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="menu_info">
                    <button
                        class="menu_title"
                        :class="{ active: menu.setting.map((item) => item.idx).some((idx) => global.selectMenu === idx) }"
                    >
                        관리
                    </button>
                    <div class="menu_item">
                        <ul>
                            <template v-for="item in menu.setting">
                                <li
                                    :class="{ active: global.selectMenu === item.idx }"
                                    v-if="!item.isAdmin || (item.isAdmin && user.userInfo?.clfCd === 99)"
                                    @click="movePage(item)"
                                >
                                    {{ item.title }}
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="header_info">
            <div class="api_info">
                <p>
                    <strong>X API</strong>
                    {{ numberFormat(apiCount.totalX ? apiCount.totalX : 0) }}건 | {{ numberFormat(apiCount.leftX ? apiCount.leftX : 0) }}건
                    사용가능
                </p>
            </div>
            <div class="api_info">
                <p>
                    <strong>Serp API</strong>
                    {{ numberFormat(apiCount.totalSerp ? apiCount.totalSerp : 0) }}건 |
                    {{ numberFormat(apiCount.leftSerp ? apiCount.leftSerp : 0) }}건 사용가능
                </p>
            </div>
            <div class="user_info" :class="{ active: state.userMenu }" @click="openMenu(0)" v-click-outside="handleOutsideClick">
                <div class="user_icon">
                    <img src="@/assets/user/user_wh.png" :class="state.userMenu ? 'on' : 'off'" />
                    <img src="@/assets/user/user_bl.png" :class="!state.userMenu ? 'on' : 'off'" />
                </div>
                <div class="user_name">
                    <strong>{{ userInfo.name ? userInfo.name : userInfo.info.name }}</strong>
                    님
                    {{ userInfo.id ? userInfo.id : userInfo.info.id }}
                </div>
                <div class="user_menu shadow" :style="state.userMenu ? '' : 'display:none;'">
                    <ul>
                        <li @click="openModal(0)" class="my_info">내정보</li>
                        <li @click="logout" class="logout">로그아웃</li>
                    </ul>
                </div>
            </div>
            <div class="setting" @click="openMenu(1)" v-click-outside="handleOutsideClick2">
                <div class="setting_icon">
                    <img src="@/assets/user/Setting.png" alt="" :style="state.settingMenu ? 'display:none;' : ''" />
                    <img src="@/assets/user/Setting_bl.png" alt="" :style="state.settingMenu ? '' : 'display:none;'" />
                </div>
                <div class="setting_menu shadow" :style="state.settingMenu ? '' : 'display:none;'">
                    <ul>
                        <li @click="openModal(1)">국가설정</li>
                        <li @click="openModal(2)">자동 모니터링 설정</li>
                        <li @click="openModal(3)">키워드</li>
                        <li @click="router.push('/api/charge/log')">API 충전 이력</li>
                        <li @click="openModal(4)">도움말</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <ModalComponents
        :title="modal.title"
        :customClass="modal.customClass"
        :type="modal.type"
        :list="modal.list"
        :columns="modal.fields"
        :show="state.isModalOpen"
        :no="modal.cancel"
        :yes="modal.confirm"
        :isBg="true"
        :useBtn="modal.isBtn"
        @toggleNation="saveNations"
        @close="modalClose"
    ></ModalComponents>
    <UserModal :userInfo="userInfo.info" :show="state.isUserModal" @close="modalClose"></UserModal>
    <KeywordModal v-if="state.isKeywordModal" @close="modalClose"></KeywordModal>
    <HelperModal v-if="state.isHelperModal" @close="modalClose"></HelperModal>
</template>

<script lang="ts">
    import {
        apiService,
        onMounted,
        reactive,
        res,
        router,
        userStore,
        numberFormat,
        UserModal,
        ModalComponents,
        returnCode,
        globalStore,
        DateRange,
        watch,
    } from "@/BaseComponent";
    import HelperModal from "@/components/helperModal.vue";
    import KeywordModal from "@/components/keywordModal.vue";
    import { Client, StompSubscription } from "@stomp/stompjs";
    import SockJS from "sockjs-client";
    import { onBeforeUnmount } from "vue";
    import { useToast } from "vue-toast-notification";

    interface Menu {
        idx: number;
        title: string;
        link: string;
        isDisabled?: boolean;
    }

    export default {
        components: {
            KeywordModal,
            ModalComponents,
            UserModal,
            HelperModal,
            DateRange,
        },

        setup() {
            const user = userStore();
            const global = globalStore();
            const { changeCode } = returnCode();
            const toast = useToast();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,
                isModalOpen: false,
                isUserModal: false,
                isKeywordModal: false,
                isHelperModal: false,
                position: [] as any,
                dept: [] as any,
            });
            const apiCount = reactive({
                totalX: user.apiCnt?.totalX ? user.apiCnt.totalX : 0,
                leftX: user.apiCnt?.leftX ? user.apiCnt.leftX : 0,
                totalSerp: user.apiCnt?.totalSerp ? user.apiCnt.totalSerp : 0,
                leftSerp: user.apiCnt?.leftSerp ? user.apiCnt.leftSerp : 0,
            });
            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const menu = reactive({
                platform: [
                    { idx: 0, title: "검색", link: "/" },
                    { idx: 1, title: "검색 관리", link: "/search/history" },
                    { idx: 2, title: "모니터링", link: "/monitoring" },
                    { idx: 3, title: "통계", link: "/statistics" },
                ] as Menu[],
                watcherBot: [
                    // { idx: 4, title: "검색", link: "/watcherbot/search" },
                    { idx: 5, title: "채팅방 리스트", link: "/watcherbot/result" }, //검색관리
                    { idx: 6, title: "탐지 결과", link: "/ai/watcher_bot" }, //ai왓쳐봇
                    { idx: 7, title: "통계", link: "/watcherbot/statistics" },
                ] as Menu[],
                setting: [
                    { idx: 98, title: "사용자관리", link: "/management/account", isAdmin: true },
                    { idx: 99, title: "API충전이력", link: "/api/charge/log" },
                ],
            });

            onMounted(() => {
                getUserInfo();
                getBalance();
                if (global.searchDate.length === 0) {
                    const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                    const endDate = new Date();
                    state.searchDate = [startDate, endDate];
                    global.setSearchDate([startDate, endDate]);
                } else {
                    state.searchDate = global.searchDate;
                }

                connectWebSocket();
            });

            onBeforeUnmount(() => {
                disconnectWebSocket();
            });

            watch(
                () => global.searchDate,
                (newDate) => {
                    state.searchDate = newDate;
                },
            );

            let stompClient: Client | null = null;
            let notificationSub: StompSubscription | null = null;

            const connectWebSocket = () => {
                stompClient = new Client({
                    webSocketFactory: () => new SockJS(process.env.VUE_APP_WSS_URL),

                    connectHeaders: {
                        Authorization: `Bearer ${user.token}`,
                    },

                    reconnectDelay: 5000,

                    onConnect: () => {
                        // console.log("WebSocket connected");

                        notificationSub = stompClient!.subscribe("/topic/notification", (message) => {
                            toast.open({
                                message: message.body,
                                type: "success",
                                onClick: () => {
                                    router.push({ name: "WatcherBot" });
                                },
                            });
                            // console.info(JSON.parse(message.body));
                        });
                    },

                    onDisconnect: () => {
                        // console.log("WebSocket disconnected");
                    },
                });

                stompClient.activate();
            };

            const disconnectWebSocket = () => {
                if (notificationSub) {
                    notificationSub.unsubscribe();
                    notificationSub = null;
                }

                if (stompClient && stompClient.active) {
                    stompClient.deactivate();
                    stompClient = null;
                }
            };

            const handleOutsideClick = () => {
                state.userMenu = false;
            };

            const handleOutsideClick2 = () => {
                state.settingMenu = false;
            };

            const getNationList = async () => {
                const res = await apiService.base.getNationList();
                if (res.returnCode === 0) {
                    global.setNationList(res.list);
                }
            };

            const getUserInfo = async () => {
                const res: res = await apiService.membar.getInfo();
                if (res.returnCode === 0) {
                    const info = {
                        id: res.data.id,
                        name: res.data.name,
                        twitterId: res.data.twitterId,
                        clfCd: res.data.clfCd,
                    };
                    user.setInfo(info);
                    userInfo.info = res.data;
                    userInfo.name = res.data.name;
                    userInfo.id = res.data.id;
                }
            };

            const getBalance = async () => {
                const res: res = await apiService.search.getBalance();
                if (res.searchApiTotal) {
                    apiCount.totalSerp = res.searchApiTotal;
                    apiCount.leftSerp = res.searchApiBalance;
                    apiCount.totalX = res.xapiTotal;
                    apiCount.leftX = res.xapiBalance;
                    user.apiCnt = {
                        totalSerp: res.searchApiTotal,
                        leftSerp: res.searchApiBalance,
                        totalX: res.xapiTotal,
                        leftX: res.xapiBalance,
                    };
                } else {
                    apiCount.totalSerp = 0;
                    apiCount.leftSerp = 0;
                    apiCount.totalX = 0;
                    apiCount.leftX = 0;
                }
            };

            const modifyMyInfo = async (data: any) => {
                const res = await apiService.membar.modifyUser(data);
                if (res.returnCode === 0) {
                    alert("정보수정이 완료 되었습니다");
                }
            };

            const logout = () => {
                if (confirm("로그아웃 하시겠습니까?")) {
                    user.setToken(null);
                    router.replace("/login");
                    disconnectWebSocket();
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            const openModal = async (menuIdx: number) => {
                const useBtn = userInfo.info.clfCd === 99 ? true : false;
                switch (menuIdx) {
                    case 0:
                        getUserInfo();
                        modal.actionCode = 1;
                        state.isUserModal = true;
                        break;
                    case 1:
                        modal.actionCode = 2;
                        modal.type = "nation";
                        modal.title = "구글 나라별 검색";
                        modal.customClass = {
                            wrap: ["nation_modal"],
                            button: ["full"],
                        };
                        modal.confirm = "저장";
                        modal.cancel = "";
                        modal.list = global.nationList;
                        state.isModalOpen = true;
                        modal.isBtn = useBtn;
                        break;

                    case 2:
                        modal.actionCode = 3;
                        modal.type = "monitoring";
                        modal.title = "자동 모니터링 설정";
                        modal.customClass = {
                            wrap: ["user_moniter_modal"],
                            button: ["full"],
                        };
                        modal.isBtn = useBtn;
                        modal.confirm = "저장";
                        modal.cancel = "";
                        getAutoMonitor();
                        break;
                    case 3:
                        state.isKeywordModal = true;
                        break;
                    case 4:
                        state.isHelperModal = true;
                        break;
                }
            };

            const getAutoMonitor = async () => {
                const res: any = await apiService.base.getAutoMonitoring();
                if (res.returnCode === 0) {
                    modal.list = [
                        { title: "twitter", label: "X 유사도", type: "number", value: res.twitter },
                        { title: "moniValue", label: "이미지 유사도", type: "number", value: res.image },
                    ];
                    state.isModalOpen = true;
                } else if (res.returnCode !== 11) {
                    alert(changeCode(res.returnCode));
                }
            };

            const saveNations = async (data: any) => {
                let res: res;
                res = await apiService.base.saveNaion(data.idx);
                if (res.returnCode !== 0) {
                    alert(res.description);
                }
            };

            const saveAutoMonit = async (twitter: number, image: number) => {
                const res = await apiService.base.saveAutoMonitoring(twitter, image);
                if (res.returnCode === 0) {
                    return alert("변경 완료되었습니다.");
                } else if (res.returnCode !== 11) {
                    return alert(changeCode(res.returnCode));
                }
            };

            const modalClose = (result: any, data: any) => {
                state.isModalOpen = false;
                state.isUserModal = false;
                state.isKeywordModal = false;
                state.isHelperModal = false;
                if (result) {
                    switch (modal.actionCode) {
                        case 1:
                            modifyMyInfo(data);
                            modal.actionCode = 0;
                            break;
                        case 2:
                            modal.actionCode = 0;
                            break;
                        case 3:
                            saveAutoMonit(data.monitValue[0], data.monitValue[1]);
                            modal.actionCode = 0;
                            break;

                        default:
                            break;
                    }
                } else {
                    switch (modal.actionCode) {
                        case 2:
                            getNationList();
                            modal.actionCode = 0;
                            break;
                    }
                }
            };

            const selectDate = (date: any) => {
                state.searchDate = date;
                global.setSearchDate(date);
            };

            const movePage = (item: Menu) => {
                if (item.isDisabled) return;
                global.setSelectMenu(item.idx);
                router.push(item.link);
            };

            return {
                state,
                userInfo,
                apiCount,
                menu,
                modal,
                global,
                user,
                openMenu,
                logout,
                openModal,
                modalClose,
                router,
                numberFormat,
                handleOutsideClick,
                handleOutsideClick2,
                saveNations,
                selectDate,
                movePage,
            };
        },
    };
</script>
<style>
    .header_info .user_info {
        min-width: 170px;
    }
    .header_logo {
        display: flex;
        gap: 40px;
    }
    .setting_menu > ul li::after {
        content: "";
        position: absolute;
        right: 13px;
        width: 25px;
        height: 25px;
        background-size: contain;
        background-image: url(../../assets/common/mingcute_right-line.png);
    }
    .setting_menu > ul li:hover:after {
        background-image: url(../../assets/common/right-white.png);
    }

    .v-toast__item--success {
        background-color: var(--lightBlue) !important;
    }
</style>
